import { createElement } from 'react';
import ReactDOM from 'react-dom';
import { StatusUpdateItem } from './status_update_item';

const createReactClass = require('create-react-class');

const StatusUpdateResults = createReactClass({
  componentDidMount() {
    $('.dashboard-feed').delegate('#load_more', 'ajax:complete', (event, data) => {
      data = $.parseJSON(data.responseText);
      const $dashboardFeed = $('.dashboard-feed');
      const $loading = $("<div id='loading'></div>");
      $loading.appendTo($dashboardFeed);
      if (data.status_updates) {
        const component = createElement(StatusUpdateResults, { status_updates: data.status_updates });
        ReactDOM.render(component, $loading[0]);
      }
      $loading.children().first().children();
      $loading.children().unwrap();
      if (data.next_link) {
        const loadMoreParent = $('#load_more').parents('.comment.load-more');
        loadMoreParent.remove();
        $('.dashboard-feed').append(loadMoreParent);
        $('#load_more').remove();
        loadMoreParent.append(data.next_link);
      } else {
        $('#load_more').parents('.comment.load-more').addClass('hidden');
      }
    });
  },
  renderStatusUpdates() {
    // the paginated response comes back with s.status_update while the original response
    // returns just the status_update object. 
    let statusUpdate;

    return this.props.status_updates.map(s => {
      statusUpdate = s.status_update || s;
      return <StatusUpdateItem status_update={statusUpdate} user={statusUpdate.user} />;
    });
  },
  render() {
    return <div>{this.renderStatusUpdates()}</div>;
  }
});

export { StatusUpdateResults };
